<template>
  <div class="article-content">
    <h2 class="article-content__title">{{ data.title }}</h2>
    <div class="article-content__body" v-html="data.content"></div>
  </div>
</template>

<script>
export default {
  name: 'article-content',
  props: ['data']
}
</script>

<style lang="css">
.article-content__body p {
  line-height: 180%;
  margin-bottom: 8.5px;
  font-size: 14px;
}
.article-content h3 {
  font-size: 14px;
  line-height: 30px;
}
</style>
<style lang="scss" scoped>
@import 'src/scss/entry';

@include b(article-content) {
  box-sizing: border-box;
  width: 1200px;
  padding: 35px;
  margin: 0 auto;
  background-color: #fff;
  @include e(title) {
    margin-top: 17px;
    margin-bottom: 8.5px;
    line-height: 40px;
    font-size: 18px;
    text-align: center;
    padding: 0 0 10px 0;
    border-bottom: 1px solid #e9e9e9;
    font-weight: bold;
  }
  @include e(body) {
    overflow: hidden;
    margin: 30px 0;
    text-indent: 2em;
  }
}
@include b(article-label) {
  overflow: hidden;
  margin: 30px 0;
  text-align: center;
  font-size: 14px;
  span {
    display: inline-block;
    padding-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// ./src/views/Article/components/article-content.vue